export default __webpack_public_path__ + "static/media/govG.1a7160b9.png";